var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"fixed":""}},[(_vm.loading)?_c('v-progress-linear',{staticStyle:{"margin":"0"},attrs:{"color":"primary","height":"5","indeterminate":true}}):_vm._e(),(_vm.navBar)?_c('MainNavigationBar',{staticStyle:{"z-index":"1000"}}):_vm._e(),_c('v-layout',{staticClass:"sg-main-content",attrs:{"column":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }